const numOfTicks = 49

export const baseMarks = new Array(numOfTicks).fill(0).map((_, idx) => {
  return {
    value: idx - 12,
    label: String(idx-12)
  }
})

export const ticksToShow = [-12, 0,6, 12,18, 24, 30, 36]

export const initialMarks = baseMarks.filter(m=> ticksToShow.includes(Number(m.label)))

export const marksStartingFromZero = new Array(39).fill(0).map((_, idx) => {
  if (idx === 0) return ({
    value: idx,
    label: "start"
  })
  return {
    value: idx,
    label: String(idx)
  }
})

export const ticksToShowFromZero = [0, 12,18, 24, 30, 36]

export type markType = {
  value: number,
  label: string
}[]